export const formFields = {
    mediaPlanName: {
        key: 'mediaPlanName',
        type: 'text',
        label: 'Media Plan Name',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        minLength: 3,
        minLengthMessage: 'Minimum 3 character allowed.',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 character allowed.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Media Plan Name </div>',
        // spaceNotAllowed: true
        // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
        // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
        patternMessage: 'Media Plan Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
    },
    brandName: {
        key: 'brandName',
        type: 'text',
        label: 'Brand Name',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        minLength: 3,
        minLengthMessage: 'Minimum 3 character allowed.',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 character allowed.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Brand Name </div>',
        // pattern: /^(?=.*?[A-Za-z]).{1,}$/
    },
    campaigncategory: {
        key: 'campaigncategory',
        label: 'Campaign Category ',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'text',
    },
    subCampaigncategory: {
        key: 'subCampaigncategory',
        label: 'Sub-Category ',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: true,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'text',
    },
    age: {
        key: 'age',
        label: 'Age',
        required: true,
        placeholder: '--Select--',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        valueKey: 'key',
        textKey: 'value',
        tooltip: '<div> Age </div>'
    },
    gender: {
        key: 'gender',
        label: 'Gender',
        placeholder: '',
        required: true,
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
        valueKey: 'key',
        textKey: 'value',
    },
    // budget: {
    //     key: 'budget',
    //     type: 'number',
    //     // label: 'Budget/month',
    //     placeholder: '',
    //     required: true,
    //     requiredMessage: 'This field is required.',
    //     minLength: 3,
    //     min: 500, // Set the minimum value
    //     // minLengthMessage: 'Minimum Budget allowed is 500$',
    //     // maxLength: 9999,
    //     // maxLengthMessage: 'Maximum 9999 character allowed.',
    //     displayLayout: 'col-md-12',
    //     tooltip: '<div> Budget </div>',
    //     pattern: /^\d+(\.\d{1,2})?$/
    // },      

    budget: {
        key: 'budget',
        type: 'number',
        label: 'Budget / month ( $ )',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        // minLength : 0,
        // minLengthMessage: 'Minimum value is 500.',
        // maxLength: 100,
        // maxLengthMessage: 'maximum 100 characters allowed.',
        min:500,
        upto2Digit:true,
        displayLayout: 'col-md-12',
        labelLayout: 'pb-4',
        tooltip: '<div> Target Value </div>',
        // pattern: /^\d+(\.\d{1,2})?$/
      },

      language: {
        key: 'language',
        label: 'Language ',
        placeholder: '--Select--',
        displayLayout: 'col-sm-12',
        required: false,
        requiredMessage: 'This field is required.',
        valueKey: 'id',
        textKey: 'text',
    },


    
    campaignObjective: {
        key: 'campaignObjective',
        label: 'Campaign Objective',
        placeholder: '--Select--',
        required: true,
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
        valueKey: 'key',
        textKey: 'value',
    },
    landingPageUrl: {
        key: 'landingPageUrl',
        type: 'text',
        label: 'Landing Page URL',
        placeholder: 'eg : https://google.com, http://google.com, www.google.com',
        required: true,
        requiredMessage: 'This field is required.',
        minLength: 3,
        // minLengthMessage: 'Minimum 3 charactors allowed.',
        maxLength: 100,
        // maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Landing Page URL </div>',
        pattern: /^(ftp|www|http|https)(:\/\/|.)[^ "]+$/
        // pattern: /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/,
        // pattern: /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/
        
    },
    adType: {
        key: 'adType',
        type: 'checkboxGroup',
        label: 'Select Ad Type',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-7',
        tooltip: '<div> Select Ad Type </div>',
        valueKey: 'checked',
        textKey: 'value'
    },
    platform: {
        key: 'platform',
        type: 'checkboxGroup',
        label: 'Select Platform',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-7',
        tooltip: '<div> Select Platform </div>',
        valueKey: 'checked',
        textKey: 'value'
    },
    // accountID: {
    //     key: 'accountID',
    //     label: 'Facebook Accounts ',
    //     placeholder: '--Select--',
    //     displayLayout: 'col-sm-12',
    //     required: false,
    //     requiredMessage: 'This field is required.',
    //     valueKey: 'id',
    //     textKey: 'text',
    // },
};


export const roleCompetetierList = {

    name: {
        key: 'name',
        type: 'text',
        label: 'Competitors Name',
        placeholder: 'Competitors Name',
        required: true,
        requiredMessage: 'This field is required.',
        // minLength: 3,
        // minLengthMessage: 'Minimum 3 charactors allowed.',
        // maxLength: 100,
        // maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-12',
        labelLayout:'col-sm-12',
        tooltip: '<div> Competitors Name </div>',
        // pattern: /^(?=.*?[A-Za-z]).{1,}$/
    },
    url: {
        key: 'url',
        type: 'text',
        label: 'Competitors URL',
        placeholder: 'eg : https://google.com, http://google.com, www.google.com',
        required: true,
        requiredMessage: 'This field is required.',
        // minLength: 3,
        // minLengthMessage: 'Minimum 3 charactors allowed.',
        // maxLength: 100,
        // maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-12',
        labelLayout:'col-sm-12',
        tooltip: '<div> Competitors URL </div>',
        pattern: /^(ftp|www|http|https)(:\/\/|.)[^ "]+$/,
        patternMessage: 'Invalid url'

        // pattern: /^(?=.*?[A-Za-z]).{1,}$/
    },
}

export const confirmationMessage = {
    action: {
        confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
        type: 'Confirmation'
    }
}

export const successfullyMessage = {
    action: {
        confirmationMessage: 'Successfully Saved Media Plan Details',
        type: 'Success',
    }
}

// export const options = [
//   { text: 'bug', id: 1 },
//   { text: 'feature', id: 2 },
//   { text: 'documents', id: 3 },
//   { text: 'discussion', id: 5 },
// ];

export const GenderType = [
    { key: '1', value: 'Male' },
    { key: '2', value: 'Female' },
    { key: '3', value: 'All' },
]
export const campaignObjective = [
    { key: '1', value: 'WebsiteTraffic' },
    { key: '2', value: 'Branding & Reach' },
    { key: '3', value: 'Conversions / Lead Generation' },
    // { key: '4', value: 'Lead Generation' },
]
export const adTypesData = [
    { key: '1', value: 'Search', checked: true, inCludedIn:['Google Adwords'] },
    { key: '2', value: 'Display', checked: true, inCludedIn:['Google Adwords','Facebook', 'Programmatic (ION & DV360)'] },
    { key: '3', value: 'Video', checked: true, inCludedIn:['Facebook'] },
]

export const SearchPlatform = [
    { key: '1', value: 'Google Adwords', checked: false },
    // { key: '2', value: 'Facebook', checked: false },
    // { key: '3', value: 'Programmatic (ION & DV360)', checked: false },
    // {key: '4', value: 'ION',  checked: false},
]
// export const displayPlatform = [
//     { key: '1', value: 'Google Adwords', checked: false },
//     { key: '2', value: 'Facebook', checked: false },
//     { key: '3', value: 'Programmatic (ION & DV360)', checked: false },
//     // {key: '4', value: 'ION',  checked: false},
// ]

export const displayPlatform = [
    { key: '1', value: 'Google Adwords', checked: true, disabled: false, parentIndex: null },
    { key: '2', value: 'Facebook', checked: true, disabled: false, parentIndex: null },
    { key: '3', value: 'Programmatic (ION & DV360)', checked: true, disabled: false, parentIndex: 1 },
  ]

export const videoPlatform = [
    // { key: '1', value: 'Googe Ads', checked: false },
    { key: '2', value: 'Facebook', checked: false },
    { key: '3', value: 'Programmatic (ION & DV360)', checked: false },
    // {key: '4', value: 'ION',  checked: false},
]



// 

